export enum GenerationTypeEnum {
    IMAGE = 'image',
    VIDEO = 'video'
}
